<template>
  <div>
    <Head />
    <div class="layout">
      <div class="platform">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="tit">数字资产工具包</p>
              <p class="text">安全便捷的加密数字资产管理工具</p>
              <div class="download">
                <div class="d-left">
                  <a
                    class="ios"
                    href="https://testflight.apple.com/join/P3hprKuv"
                    target="view_blank"
                  >
                    <img
                      src="../../../assets/images/pc/product/digitization/iOS.png"
                      alt=""
                    />
                    <span>iOS下载</span>
                  </a>
                  <a
                    class="andorid"
                    href="https://toolserver.hwelltech.com/download/hwtool-last.apk"
                  >
                    <img
                      src="../../../assets/images/pc/product/digitization/Android.png"
                      alt=""
                    />
                    <span>Android下载</span>
                  </a>
                  <div class="andorid" @click="goChrome">
                    <img
                      src="../../../assets/images/pc/product/digitization/Chrome.png"
                      alt=""
                    />
                    <span>Chrome Extension</span>
                  </div>
                </div>
                <div class="d-right">
                  <img
                    src="../../../assets/images/pc/product/digitization/ewm.png"
                    alt=""
                  />
                  <p>扫码二维码下载</p>
                </div>
              </div>
            </div>
            <div class="right">
              <img
                src="../../../assets/images/pc/product/platform/part1.png"
                alt
              />
            </div>
          </div>
        </div>
        <div class="part-2">
          <div class="main">
            <p class="tit">产品介绍</p>
            <div class="content">
              <div class="line">
                恒为数字资产工具包是一个安全便捷的加密数字资产管理工具，能够帮助用户管理区块链账户及账户内的数字资产
              </div>
            </div>
          </div>
        </div>

        <div class="part-4">
          <div class="main">
            <p class="tit">产品特性及优势</p>
            <div class="content">
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/product/toolkit/part4-1.png"
                    alt=""
                  />
                </div>
                <div class="right">
                  <p class="title">安全</p>
                  <p class="txt">
                    区块链账户密钥本地存储，交易采用离线签名更加安全
                  </p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/product/toolkit/part4-2.png"
                    alt=""
                  />
                </div>
                <div class="right">
                  <p class="title">简单</p>
                  <p class="txt">
                    操作界面简洁，可方便实现数字资产的交易和转移
                  </p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/product/toolkit/part4-3.png"
                    alt=""
                  />
                </div>
                <div class="right">
                  <p class="title">快捷</p>
                  <p class="txt">资产转账速度快，仅需3-5秒就能确认到账</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/product/toolkit/part4-4.png"
                    alt=""
                  />
                </div>
                <div class="right">
                  <p class="title">真实</p>
                  <p class="txt">
                    基于区块链技术，资产的转移和交易直接在链上进行
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="part-5">
          <div class="main">
            <p class="tit">产品核心功能</p>
            <div class="content">
              <div class="card">
                <div class="img">
                  <img
                    src="../../../assets/images/pc/product/toolkit/part5-1.png"
                    alt=""
                  />
                </div>
                <div class="text">账户管理</div>
              </div>
              <div class="card">
                <div class="img">
                  <img
                    src="../../../assets/images/pc/product/toolkit/part5-2.png"
                    alt=""
                  />
                </div>
                <div class="text">资产管理</div>
              </div>
              <div class="card">
                <div class="img">
                  <img
                    src="../../../assets/images/pc/product/toolkit/part5-3.png"
                    alt=""
                  />
                </div>
                <div class="text">去中心化交易</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/pc/Head";
import Foot from "../../../components/pc/Foot";
import api from "../../../common/api";
import { Button } from "iview";

export default {
  name: "service",
  components: {
    Head,
    Foot,
    Button,
  },
  data() {
    return {
      cn: false,
      en: false,
    };
  },
  mounted() {
    this.mobile();
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      if (localStorage.Lang == "en") {
        this.en = true;
      } else {
        this.cn = true;
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
    /*跳转到ChromeExtension页*/
    goChrome() {
      this.$router.push({ name: "chromeExtension" });
    },
  },
};
</script>
<style  lang="less"  scoped>
@import url("../../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.platform {
  .part-1 {
    width: 100%;
    .p1();
    background: linear-gradient(171deg, #1d3ede, #108eea);
    .main {
      .clearfix();
    }
    .left {
      width: 50%;
      float: left;
      .tit {
        .hTit();
        margin: 150px 0 10px 0;
      }
      .text {
        width: 522px;
        .hText();
      }
      .download {
        display: flex;
        justify-content: flex-start;
        .d-left {
          width: 200px;
          .ios,
          .andorid {
            width: 220px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 23px;
            padding: 0 15px;
            cursor: pointer;
            img {
              width: 27px;
            }
            span {
              display: inline-block;
              color: #fff;
              width: 140px;
              font-size: 16px;
            }
          }
          .ios {
            margin-top: 30px;
          }
          .andorid {
            margin-top: 20px;
          }
        }
        .d-right {
          text-align: center;
          margin-left: 55px;
          padding-top: 60px;
          img {
            width: 100px;
          }
          p {
            color: #fff;
            font-size: 16px;
          }
        }
      }
    }
    .right {
      width: 50%;
      float: left;
      img {
        margin: 60px 0 0 170px;
        width: 358px;
        height: 400px;
      }
    }
  }
  .part-2 {
    background: #fff;
    padding: 80px 0 80px;
    .main {
      .clearfix();
      height: 100%;
      padding: 0;
      .tit {
        .onlyTit();
      }

      .content {
        width: 100%;
        height: 100%;
        text-align: center;
        .line {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
  .part-3 {
    background: #fff;
    padding: 80px 0 80px;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        height: 100%;
        text-align: center;
        img {
          width: 956px;
          height: 504px;
        }
      }
    }
  }
  .part-4 {
    padding: 80px 0 80px;
    background: #f9f9f9;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        //justify-content: space-around;
        .card {
          width: 550px;
          height: 184px;
          display: flex;
          padding: 38px 20px;
          background: #ffffff;
          margin: 10px;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          .left {
            width: 179px;
            img {
              height: 100%;
              height: 108px;
            }
          }
          .right {
            width: 331px;
            padding: 20px 0 0 20px;

            .title {
              color: #444444;
              font-size: 20px;
              text-align: left;
              margin-bottom: 10px;
            }
            .txt {
              color: #888888;
              text-align: left;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .part-5 {
    padding: 80px 0 80px;
    background: #ffffff;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        .card {
          width: 160px;
          height: 170px;
          background: #ffffff;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          text-align: center;
          padding: 37px 0 35px;
          margin: 15px;
          .img {
            margin-bottom: 18px;
            height: 50px;
            img {
              height: 100%;
              width: auto;
            }
          }
          .text {
            color: #444444;
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>